module.exports = __webpack_public_path__ + "files/d76917e8e90bc94640128a608c5198f6.svg";